import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

@Component({
  selector: 'app-filter-chip',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './filter-chip.component.html',
  styleUrl: './filter-chip.component.scss',
})
export class FilterChipComponent {
  readonly label = input.required<string>();
  readonly count = input<number | null>(null);
  readonly active = input<boolean>(false);
  readonly caret = input<boolean>(false);
  readonly pill = input<boolean>(false);
  readonly countLabel = input<string | null>(null);

  readonly clicked = output<void>();

  /**
   * Zaehlpille sichtbar? Regel unterscheidet zwischen Chip und Pill: der Chip
   * versteckt Null- und Nullwerte („keine Meldung"), die Pill zeigt Null immer
   * an, weil der Segmented-Filter die Gesamtzahl auch bei 0 kommuniziert.
   * Als computed statt Ternary im Template — die verdeckte Kopplung von
   * `pill` und `count` wird so ausformuliert (fboudouhi Review).
   */
  readonly showCount = computed(() => {
    const c = this.count();
    if (c === null || c === undefined) return false;
    return this.pill() ? true : c > 0;
  });
}
